import { API, Auth } from "aws-amplify";
import React, { useState } from "react";
import { calcuratorInterestTwo } from "services";
import { calReportAging } from "utils/calReportAging";
import { pad } from "utils/getLocalDateTime";
import { reinstallments } from "utils/reinstallments";
import { Button } from "./wrapper";
import _ from "lodash";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";

function LastPaymentDone({
  setLoan,
  setOriLoan,
  loan = [],
  agingDate = new Date(),
  buroDate = new Date(),
  setIsSelectAll,
  setCount,
  count,
  setDisabledAging,
  disabledAging,
  setDisabledLastPayment,
  disabledLastPayment,
  setLoanNotCal,
  setLoanLastPaymentDone,
}) {
  const [localCount, setLocalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickLastPayment = async () => {
    try {
      setLoading(true);
      setDisabledAging(true);
      setDisabledLastPayment(true);

      let data = {};
      let localCountFunc = 0;
      let lastItem = null;
      let keepLoan = [];
      let loanNotCal = [];

      const dataResponse = await await API.get("MoneyHubAdmin", "/interest", {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const interest = JSON.parse(dataResponse.body);

      const selectMonth = new Date(agingDate);
      let today = new Date(agingDate);
      let lastDate = today.getDate();
      let paid_date = new Date();

      if (selectMonth.getMonth() === today.getMonth()) {
        paid_date = `${selectMonth.getFullYear()}-${pad(
          selectMonth.getMonth() + 1
        )}-${pad(today.getDate())}`;
      } else {
        const newToday = new Date(
          selectMonth.getFullYear(),
          selectMonth.getMonth() + 1,
          0
        );
        lastDate = newToday.getDate();
        paid_date = `${selectMonth.getFullYear()}-${pad(
          selectMonth.getMonth() + 1
        )}-${pad(newToday.getDate())}`;
      }

      // 400034857
      // 400211052

      // const includeLoans = [
      //   "400130199",
      //   "400211052",
      //   "400059036",
      //   "400015556",
      //   "400109048",
      //   "500023095",
      //   "400078958",
      //   "400035254",
      //   "400032536",
      //   "400162378",
      //   "500142736",
      //   "500048444",
      //   "500125302",
      //   "400034857",
      //   "500039785",
      // ];

      let bigLoan = loan;

      // console.log("loan", loan);
      // bigLoan = bigLoan.filter(
      //   (loanItem) =>
      //     !["400046167", "400082940"].includes(loanItem.loan_kbank_id)
      // );
      for (const loan of bigLoan) {
        const calNewLoan = calcuratorInterestTwo(loan, {
          where: { paid_date: new Date(paid_date) },
          dataInterest: interest,
        });

        // console.log("calNewLoan", calNewLoan);

        let newLoan = calNewLoan;
        if (
          [
            "400015487",
            "400026468",
            "400049324",
            "500024941",
            "500037686",
            "500119031",
            "400181853"
          ].includes(loan?.loan_kbank_id)
        ) {
          newLoan = reinstallments(calNewLoan, new Date(paid_date), interest);
        }

        // const newLoan = reinstallments(
        //   calNewLoan,
        //   new Date(paid_date),
        //   interest
        // );

        let includeLoan = { ...calNewLoan, ...newLoan, original: loan, checked: true };

        if (includeLoan?.evidence?.length > 0) {
          let lastPaymentDate = getCurrentLocalDateTime(
            new Date(
              includeLoan.evidence[includeLoan.evidence.length - 1].paid_date
            )
          );
          let buroFullDateMin = new Date(buroDate);
          buroFullDateMin.setDate(1);
          let buroFullDateMax = getCurrentLocalDateTime(
            new Date(buroDate)
          ).fullDate;

          if (
            lastPaymentDate.fullDate >=
              getCurrentLocalDateTime(buroFullDateMin).fullDate &&
            lastPaymentDate.fullDate <= buroFullDateMax &&
            includeLoan.loan_status === "DONE"
            // loan.loan_kbank_id === "400046167" ||
            // loan.loan_kbank_id === "400082940"
          ) {
            keepLoan.push({ ...includeLoan });
          }
        }
      }

      // do {
      //   data = await API.get("MoneyHubAdmin", "/loan/sandbox/agingReport", {
      //     queryStringParameters: {
      //       paid_date: agingDate,
      //       ExclusiveStartKey: getLastItem(lastItem),
      //     },
      //     headers: {
      //       Authorization: `Bearer ${(await Auth.currentSession())
      //         .getIdToken()
      //         .getJwtToken()}`,
      //     },
      //   });
      //   lastItem = data?.lastItem;

      //   let filterLoan = data?.Items?.map((loan) => {
      //     loanNotCal.push(loan);

      //     const calNewLoan = calcuratorInterestTwo(loan, {
      //       where: { paid_date: new Date(paid_date) },
      //       dataInterest: interest,
      //     });

      //     // const newLoan = reinstallments(
      //     //   calNewLoan,
      //     //   new Date(paid_date),
      //     //   interest
      //     // );

      //     let includeLoan = { ...calNewLoan, original: loan, checked: true };

      //     if (includeLoan?.evidence?.length > 0) {
      //       let lastPaymentDate = getCurrentLocalDateTime(
      //         new Date(
      //           includeLoan.evidence[includeLoan.evidence.length - 1].paid_date
      //         )
      //       );
      //       let buroFullDateMin = new Date(buroDate);
      //       buroFullDateMin.setDate(1);
      //       let buroFullDateMax = getCurrentLocalDateTime(
      //         new Date(buroDate)
      //       ).fullDate;

      //       if (
      //         lastPaymentDate.fullDate >=
      //           getCurrentLocalDateTime(buroFullDateMin).fullDate &&
      //         lastPaymentDate.fullDate <= buroFullDateMax &&
      //         includeLoan.loan_status === "DONE"
      //       ) {
      //         return { ...includeLoan };
      //       }
      //     }

      //     return null;
      //     //   if (
      //     //     includeLoan.loan_status === "ACTIVE" ||
      //     //     includeLoan.loan_status === "FAIL"
      //     //   ) {
      //     //     return { ...calNewLoan, ...newLoan, checked: true };
      //     //   }
      //   }).filter((item) => item !== null);

      //   localCountFunc += filterLoan?.length;
      //   keepLoan.push(...filterLoan);
      //   setLocalCount(localCountFunc);
      // } while (lastItem);

      // setOriLoan((prev) => [...prev, ..._.cloneDeep(keepLoan)]);
      // setLoan((prev) => [...prev, ..._.cloneDeep(keepLoan)]);
      // setLoanNotCal((prev) => [...prev, ..._.cloneDeep(loanNotCal)]);
      setLoanLastPaymentDone(keepLoan);
      // setCount((prev) => prev + keepLoan.length);
      setLocalCount(keepLoan.length);
      setIsSelectAll(true);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
      setDisabledAging(true);
      setDisabledLastPayment(true);
    }
  };

  return (
    <div className="flex space-x-2 w-full">
      <Button
        loading={loading}
        disabled={disabledLastPayment}
        onClick={onClickLastPayment}
      >
        {localCount > 0 && localCount} LastPaymentDone
      </Button>
    </div>
  );
}

export default LastPaymentDone;
